import { render, staticRenderFns } from "./KsSqiNo1.vue?vue&type=template&id=3cbaaa45&scoped=true"
import script from "./KsSqiNo1.vue?vue&type=script&lang=js"
export * from "./KsSqiNo1.vue?vue&type=script&lang=js"
import style0 from "./KsSqiNo1.vue?vue&type=style&index=0&id=3cbaaa45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbaaa45",
  null
  
)

export default component.exports